module.exports = __webpack_public_path__ + "static/media/vertical_for_cherry_tomato_blog.906a5934.webp";